export const facebookPixel = {
  title: "Facebook Pixel",
  description:
    "Conecta tu Facebook Pixel para rastrear el tráfico y las conversiones de tu tienda.",
  configure: "Configurar",
  edit: "Editar",
  disconnect: "Desconectar",
  disconnectConfirm: "¿Deseas desconectar Facebook Pixel de tu tienda?",
  disconnectSuccess: "Facebook Pixel desconectado",
  disconnectError: "No se pudo desconectar Facebook Pixel",
  connectedTitle: "Facebook Pixel conectado",
  connectedDescription: "Tu meta tag está activo en la tienda.",
  needTitle: "Conecta Facebook Pixel",
  needDescription:
    "Pega el meta tag de tu Pixel para medir conversiones y optimizar anuncios.",
  metaTagLabel: "Meta tag / Pixel ID",
  metaTagPlaceholder: "Pega aquí tu meta tag de Facebook Pixel",
  eventsManagerLink: "Ir a Events Manager de Meta",
  eventsManagerHint:
    "Abre el administrador de eventos de Meta, copia tu Pixel y pégalo aquí.",
  save: "Guardar",
  saving: "Guardando...",
  saveSuccess: "Facebook Pixel actualizado correctamente",
  saveError: "No se pudo actualizar Facebook Pixel",
  helpTitle: "Ayuda de Facebook Pixel",
  commonQuestions: "Preguntas frecuentes",
  helpEmpty: "No hay información de ayuda disponible por ahora.",
  acquire: {
    title: "Activa Facebook Pixel",
    description:
      "Optimiza Facebook y maximiza conversiones con datos precisos de tu tienda.",
    cta: "Adquirir complemento",
  },
};

export default facebookPixel;
